const LEGACY_CACHE_RESET_FLAG = 'vendaprocrm:pwa:legacy-cache-reset:v1';

function canUseServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return false;
  }

  const hostname = window.location.hostname;
  return window.location.protocol === 'https:'
    || hostname === 'localhost'
    || hostname === '127.0.0.1';
}

function hasCompletedLegacyCacheReset() {
  try {
    return window.localStorage.getItem(LEGACY_CACHE_RESET_FLAG) === 'done';
  } catch {
    return true;
  }
}

function markLegacyCacheResetDone() {
  try {
    window.localStorage.setItem(LEGACY_CACHE_RESET_FLAG, 'done');
  } catch {
    // If storage is blocked, do not keep clearing cache on every load.
  }
}

async function clearLegacyBrowserCacheOnce() {
  const shouldClearLegacyBrowserCache = import.meta.env.VITE_CLEAR_LEGACY_BROWSER_CACHE === 'true';
  if (!shouldClearLegacyBrowserCache || hasCompletedLegacyCacheReset()) {
    return;
  }

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));

    if ('caches' in window) {
      const keys = await window.caches.keys();
      await Promise.all(keys.map((key) => window.caches.delete(key)));
    }

    markLegacyCacheResetDone();
  } catch (error) {
    console.warn('Nao foi possivel limpar caches legados do PWA:', error);
  }
}

export function registerVendaproPwa() {
  if (!canUseServiceWorker()) {
    return;
  }

  window.addEventListener('load', () => {
    clearLegacyBrowserCacheOnce()
      .then(() => navigator.serviceWorker.register('/sw.js', {
        scope: '/',
        updateViaCache: 'none'
      }))
      .then((registration) => {
        window.setInterval(() => {
          registration.update().catch(() => {});
        }, 60 * 60 * 1000);
      })
      .catch((error) => {
        console.warn('Nao foi possivel registrar o PWA:', error);
      });
  });
}
